import React, { useState } from 'react'
import Header from './Header'
import Footer from './Footer'
import downloadimage from '../assets/downloadapp.png'
import { useParams } from 'react-router-dom'

const Downlaoder = () => {

  const {k} = useParams();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(k);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return <>
        <Header/>
        <section class="pb-20 px-4 overflow-hidden bg-[#060d1a] pt-20">
            <div class="relative rounded-[2rem] bg-[#060d1a] border  border-[#060d1a]/90 p-8 md:p-16 flex flex-col md:flex-row items-center gap-12">
                <div class="absolute top-0 left-0 w-96 h-96 bg-[#1ebfe3]/10 rounded-full blur-[120px] -translate-x-1/2 -translate-y-1/2"></div>
                <div class="absolute bottom-0 right-0 w-96 h-96 bg-[#ff8fd2]/10 rounded-full blur-[120px] translate-x-1/2 translate-y-1/2"></div>
                <div class="flex-1 flex flex-col gap-6 text-center md:text-left relative z-10">
                <h2 class="text-[#0d191c] dark:text-white text-4xl md:text-5xl font-black leading-tight tracking-tight">Download Beeppee to view.</h2>
                <p class="text-[#4b8e9b] dark:text-gray-400 text-xl font-medium leading-relaxed max-w-md mx-auto md:mx-0">
                        Track on the go with Beeppee mobile app for real-time alerts and location updates. Control all your devices from the palm of your hand.
                    </p>
                <div class="flex flex-wrap justify-center md:justify-start gap-4 mt-4">
                   <a class="inline-flex items-center gap-2 bg-black text-white px-5 py-2.5 rounded-xl hover:bg-gray-900 transition-colors border border-gray-800 shadow-lg"
                  href="https://beeppeeappmode.web.app/" 
                  target="_blank" 
                  rel="noopener noreferrer">
                    <svg class="size-8" fill="currentColor" viewBox="0 0 384 512">
                    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"></path>
                    </svg>
                    <div class="text-left" onClick={handleCopy}>
                        <p class="text-[10px] uppercase font-bold leading-none">Download on the</p>
                        <p class="text-xl font-bold leading-tight">App Store</p>
                    </div>
                 </a>


                <a class="inline-flex items-center gap-2 bg-black text-white px-5 py-2.5 rounded-xl hover:bg-gray-900 transition-colors border border-gray-800 shadow-lg"
                  href="https://beeppeeappmode.web.app/" 
                  target="_blank" 
                  rel="noopener noreferrer">
                <svg class="size-8" fill="currentColor" viewBox="0 0 512 512">
                <path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"></path>
                </svg>
                
                <div class="text-left"  onClick={handleCopy}>
                    <p class="text-[10px] uppercase font-bold leading-none">Get it on</p>
                    <p class="text-xl font-bold leading-tight">Google Play</p>
                </div>
                </a>


                  <a class="inline-flex items-center gap-2 bg-black text-white px-5 py-2.5 rounded-xl hover:bg-gray-900 transition-colors border border-gray-800 shadow-lg"
                  href="https://beeppeeappmode.web.app/" 
                  target="_blank" 
                  rel="noopener noreferrer">

                    
                    
                    <div class="text-left w-80 flex justify-center flex-col p-2" onClick={handleCopy}>
                        <p class="text-[10px] uppercase font-bold leading-none self-center">Downloaded app?</p>
                        <p class="text-xl font-bold leading-tight self-center">Auto Signin and Use as Guest</p>
                    </div>
                 </a>
                </div>
                </div>
                <div class="flex-1 relative flex justify-center items-center">
                <div class="relative w-64 md:w-72 aspect-[9/18.5] bg-black rounded-[3rem] p-3 shadow-2xl ring-8 ring-gray-200 dark:ring-gray-800">
                <div class="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-7 bg-black rounded-b-3xl z-20 flex items-center justify-center">
                <div class="w-12 h-1 bg-gray-800 rounded-full"></div>
                </div>
                <div class="relative w-full h-full rounded-[2.2rem] overflow-hidden bg-white">
                <div class="absolute inset-0 bg-cover bg-center" style={{backgroundImage:`url(${downloadimage})`}}></div>
                <div class="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-primary/20"></div>
                </div>
                </div>
                <div class="absolute -top-4 -right-4 bg-accent-pink text-white p-4 rounded-2xl shadow-xl animate-bounce hidden md:block">
                <span class="material-symbols-outlined">notifications_active</span>
                </div>
                <div class="absolute bottom-10 -left-8 bg-primary text-white p-4 rounded-2xl shadow-xl hidden md:block">
                <span class="material-symbols-outlined">share_location</span>
                </div>
                </div>
             </div>
          </section>
        <Footer/>
    </>
}

export default Downlaoder
